/**
 * TODO:
 *
 * - preset of props
 * - ...
 *
 */
export const KEYS = { initial: 'initial', animate: 'enter', exit: 'exit' }
